<div class="w-full h-full bg-black flex flex-col justify-start items-center">


    <div class="relative  camera-feed ">
        <video #videoElement class="w-full absolute top-0 camera-feed "></video>
        <div
            class="flex flex-col justify-center items-center  absolute top-0 z-20 {{ processing ? '' : 'hidden'}}  w-full h-full">
            <div class="p-2 rounded-full backdrop-blur-xl animate-spin text-white w-12 h-12">

                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-full h-full">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4" />
                    <path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4" />
                </svg>
            </div>
        </div>
        <canvas #canvasElement class=" w-full  absolute top-0 camera-feed  z-10 {{ processing ? '' : 'hidden'}}"></canvas>

    </div>


    <button (click)="captureFrame()" class="sticky bottom-4 bg-white camera-button white rounded-full p-2">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" class="w-10 h-10 ">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path
                d="M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2" />
            <path d="M9 13a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
        </svg>
    </button>

    <!-- <button (click)="stopScanning()" [disabled]="!isScanning">Stop Scanning</button> -->
    <div  class="text-white w-11/12 p-2 flex flex-col gap-2">
        <p>Elementi scansionati:</p>
        @for( item of [].constructor(10); track item){
        <div class="bg-white/20 p-2 rounded-3xl flex justify-between items-center">

            <div class="flex flex-col">
                <div class="flex justify-between items-center">
                    <p class="text-xl font-medium">SCATOLA INCASTRATA NEL RULLO</p>
                    <div class="flex justify-center items-center">
                        <button class="p-2 rounded-full edit-button">
                            <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="w-4 h-4">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" />
                                <path d="M13.5 6.5l4 4" />
                            </svg>
                        </button>
                        <button class="p-2 rounded-full delete-button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <line x1="18" y1="6" x2="6" y2="18" />
                                <line x1="6" y1="6" x2="18" y2="18" />
                            </svg>
                        </button>
                    </div>
                </div>
                
                <div class="flex flex-col p-2 bg-red-500/30 rounded-2xl">
                    <p class="text-sm font-light">Nessun match trovato a sistema.</p>
                    <div class="flex justify-center items-center">

                        <button class="rounded-full edit-button w-full" style="padding: 0.2rem!important;">
                            <p class="text-sm">Cerca errori simili</p>
                        </button>
                        <button class="rounded-full e-flat-add w-full" style="padding: 0.2rem!important;">
                            <p class="text-sm">Aggiungi</p>
                        </button>
                    </div>
                </div>
            </div>
            
        </div>
        }
    </div>

    <div *ngIf="recognizedText.length == 0" class="text-white p-2 ">
        <p>Scansiona per vedere i risultati</p>

    </div>



</div>